module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0663.16a707b1.jpg";